import angular from 'angular';
import uiRouter from 'angular-ui-router';
import menuOptionsFamilyComponent from './menuOptionsFamily.component';

let menuOptionsFamilyModule = angular.module('menuOptionsFamily', [
  uiRouter
])

.component('menuOptionsFamily', menuOptionsFamilyComponent)

.name;

export default menuOptionsFamilyModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/menuFamilyNeedALoan/menuOptionsFamily/menuOptionsFamily.js